import type { EdsNormalizedValidationResult } from '@/features/eds/types/normalizedValidationResult';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsValidationSetFieldEvent extends EventV2<EdsNormalizedValidationResult> {}
